export default function isWhole(num: number): boolean {
  return num - Math.floor(num) === 0;
}
